import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCheckOutline = function SvgCheckOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6534 4.1178C20.0026 4.34057 20.1051 4.80425 19.8823 5.15346L10.0728 20.5305L4.16752 13.2493C3.90661 12.9276 3.95589 12.4553 4.27759 12.1944C4.5993 11.9335 5.07161 11.9828 5.33253 12.3045L9.92723 17.9697L18.6177 4.34673C18.8405 3.99752 19.3042 3.89503 19.6534 4.1178Z"
  })));
};

export { SvgCheckOutline as ReactComponent };
//# sourceMappingURL=check-outline.svg.js.map
